var map = {
	"./ESG.js": "mimX",
	"./aboutUs.js": "pQ3y",
	"./fund.js": "SD3G",
	"./main.js": "Yjer"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "33S5";


//////////////////
// WEBPACK FOOTER
// ./src/routers/module nonrecursive \.js$
// module id = 33S5
// module chunks = 22